import React from "react";
import { BeatLoader } from "react-spinners";
import CountUp from "react-countup";
import "../coronaStats.css";

export const DataStats = ({ data }) => {
  console.log(data);
  return (
    <React.Fragment>
      <div className="bg-color-sky-light">
        <div className="content-md container">
          <div className="row">
            <div
              className="col-md-3 md-margin-b-30"
              style={{ backgroundColor: "#ffbe07" }}
            >
              <div className="pricing-list-v4 radius-10">
                <div className="pricing-list-v4-header">
                  <h4 className="pricing-list-v4-title">Confirmed</h4>
                  <span className="pricing-list-v4-subtitle">Covid - 19</span>
                </div>
                <div className="pricing-list-v4-content">
                  <div className="margin-b-40">
                    <span className="pricing-list-v4-price-sign">
                      <i className="fa fa-dollar"></i>
                    </span>
                    <span className="pricing-list-v4-price">
                      {!data.confirmed.value ? (
                        <BeatLoader loading color="black" />
                      ) : (
                        <CountUp
                          end={data.confirmed.value}
                          duration={2}
                          suffix={"+"}
                        />
                      )}
                    </span>
                    {/* <span className="pricing-list-v4-subprice">00</span>
                    <span className="pricing-list-v4-price-info">Month</span> */}
                  </div>
                  <div className="center-block">
                    <button
                      onClick={() => {
                        if (window.innerWidth >= 480) {
                          window.scrollTo(0, 500);
                        } else {
                          window.scrollTo({
                            top: 1200,
                            behavior: "smooth"
                          });
                        }
                      }}
                      type="button"
                      className="btn-dark-brd btn-base-sm radius-3"
                    >
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-3 md-margin-b-30"
              style={{ backgroundColor: "#ff2929" }}
            >
              <div className="pricing-list-v4 radius-10">
                <div className="pricing-list-v4-header">
                  <h4 className="pricing-list-v4-title">Deaths</h4>
                  <span className="pricing-list-v4-subtitle">Covid - 19</span>
                </div>
                <div className="pricing-list-v4-content">
                  <div className="margin-b-40">
                    <span className="pricing-list-v4-price-sign">
                      <i className="fa fa-dollar"></i>
                    </span>
                    <span className="pricing-list-v4-price">
                      {!data.deaths.value ? (
                        <BeatLoader loading color="black" />
                      ) : (
                        <CountUp
                          end={data.deaths.value}
                          duration={4}
                          suffix={"+"}
                        />
                      )}
                    </span>
                    {/* <span className="pricing-list-v4-subprice">00</span>
                    <span className="pricing-list-v4-price-info">Month</span> */}
                  </div>
                  <div className="center-block">
                    <button
                      type="button"
                      className="btn-dark-brd btn-base-sm radius-3"
                    >
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-3 md-margin-b-30"
              style={{ backgroundColor: "#4db300" }}
            >
              <div className="pricing-list-v4 radius-10">
                <div className="pricing-list-v4-header">
                  <h4 className="pricing-list-v4-title">Recovered</h4>
                  <span className="pricing-list-v4-subtitle">Covid - 19</span>
                </div>
                <div className="pricing-list-v4-content">
                  <div className="margin-b-40">
                    <span className="pricing-list-v4-price-sign">
                      <i className="fa fa-dollar"></i>
                    </span>
                    <span className="pricing-list-v4-price">
                      {!data.recovered.value ? (
                        <BeatLoader loading color="black" />
                      ) : (
                        <CountUp
                          end={data.recovered.value}
                          duration={5}
                          suffix={"+"}
                        />
                      )}
                    </span>
                    {/* <span className="pricing-list-v4-subprice">00</span>
                    <span className="pricing-list-v4-price-info">Month</span> */}
                  </div>
                  <div className="center-block">
                    <button
                      type="button"
                      className="btn-dark-brd btn-base-sm radius-3"
                    >
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DataStats;
